var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowListMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-95ee0875-7f04-430e-9bd0-f7d00eb727d0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.32809 98.81471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-e365ca30-2180-418c-a3fe-ae9a1f91789b",
    "data-name": "arrow_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "49.91872 18.96645 80.35862 49.40645 49.91872 79.84645 49.92192 95.87735 167.87192 49.40735 49.92192 2.93735 49.91872 18.96645",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.71263,
    y: 27.95891,
    width: 42.89684,
    height: 42.89684,
    transform: "translate(91.54573 60.89509) rotate(134.99991)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.21692,
    y: 30.81192,
    width: 37.19081,
    height: 37.19081,
    transform: "translate(152.40624 35.68592) rotate(135)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.09252,
    y1: 53.98545,
    x2: 8.01552,
    y2: 53.98545,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.09252,
    y1: 44.82925,
    x2: 8.01552,
    y2: 44.82925,
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.53212 53.98545 129.06762 53.98545 136.66012 61.57795",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.53212 44.82925 129.06762 44.82925 136.66012 37.23675",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.57432 58.94325 120.29812 58.94325 126.03532 64.68045",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.57432 39.87145 120.29812 39.87145 126.03532 34.13415",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowListMobile);
export default __webpack_public_path__ + "static/media/arrow-list-mobile.d381afe7771a046d946a942428473d81.svg";
export { ForwardRef as ReactComponent };